import { render, staticRenderFns } from "./HeadCheckBox.vue?vue&type=template&id=b2bd1a78"
import script from "./HeadCheckBox.vue?vue&type=script&lang=js"
export * from "./HeadCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports